export const EVENT_CHANNEL = 'navigation' as const;
export const COMPONENT_NAME = 'GlobalTopNavigation' as const;
